import React, { useState } from 'react';
import { Question, Compass, Keyboard, Lightbulb, EnvelopeSimple } from '@phosphor-icons/react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const SHORTCUTS = [
  { keys: ['Ctrl', 'K'], desc: 'Command bar' },
  { keys: ['Ctrl', '/'], desc: 'Keyboard shortcuts' },
  { keys: ['Esc'], desc: 'Close dialogs' },
];

export default function HelpMenu({ onReplayTour }) {
  const [shortcutsOpen, setShortcutsOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="p-2 rounded-md hover:bg-muted transition-colors text-muted-foreground hover:text-foreground"
            data-testid="help-menu-trigger"
            aria-label="Help"
          >
            <Question size={20} weight="bold" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-52">
          <DropdownMenuItem onClick={onReplayTour} className="gap-2 cursor-pointer">
            <Compass size={16} />
            <span>Replay Tour</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setShortcutsOpen(true)} className="gap-2 cursor-pointer">
            <Keyboard size={16} />
            <span>Keyboard Shortcuts</span>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => window.open('mailto:support@lotmate.com', '_blank')}
            className="gap-2 cursor-pointer"
          >
            <EnvelopeSimple size={16} />
            <span>Contact Support</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Keyboard Shortcuts Modal */}
      {shortcutsOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={() => setShortcutsOpen(false)}>
          <div className="bg-card rounded-xl border shadow-2xl p-6 w-80 max-w-[90vw]" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-semibold text-base">Keyboard Shortcuts</h3>
              <button onClick={() => setShortcutsOpen(false)} className="text-muted-foreground hover:text-foreground text-sm">
                Esc
              </button>
            </div>
            <div className="space-y-3">
              {SHORTCUTS.map(({ keys, desc }) => (
                <div key={desc} className="flex items-center justify-between">
                  <span className="text-sm text-muted-foreground">{desc}</span>
                  <div className="flex gap-1">
                    {keys.map((k) => (
                      <kbd key={k} className="px-1.5 py-0.5 rounded border bg-muted text-xs font-mono">{k}</kbd>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
